import React, { useState } from "react";
import Vimeo from "@u-wave/react-vimeo";

const OrganizerSubscribeVideoAndContent = ({
  isVideoEnd,
  handleVideoEnd = () => {},
  handleButtonClick,
  isDashboard,
}) => {
  const [videoError, setVideoError] = useState(false);

  return (
    <div>
      <h1 className="text-[25px] lg:text-[40px] text-center font-bold text-black leading-[1.3]">
        {isDashboard ? (
          <>
            Scopri la <span className="text-primary">Dashboard</span>, guarda il
            video qui sotto!
          </>
        ) : (
          <>
            Scopri l’
            <span className="text-primary">organizer</span>, guarda il video qui
            sotto!
          </>
        )}
      </h1>
      <div className="find-out-card-shadow bg-white overflow-hidden mx-auto relative w-full sm:w-[600px] lg:w-[800px] h-[250px] sm:h-[400px] lg:h-[550px] rounded-[10px] mt-[28px]">
        {/* {!videoError && (
          <Vimeo
            video="https://vimeo.com/352786895"
            // autoplay
            width="100%"
            height="100%"
            responsive
            onEnd={handleVideoEnd}
            onError={() => setVideoError(true)}
            className="absolute top-0 left-0 w-full h-full"
          />
        )} */}

        <iframe
          width="100%"
          height="100%"
          src={
            isDashboard
              ? "https://www.youtube.com/embed/gorXPH-IWBQ?si=PF2vzoZVWZKOb44r"
              : "https://www.youtube.com/embed/Lof9hndO8jY?si=uKYgHSJwvr5PXYHy"
          }
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>

      <button
        disabled={!isVideoEnd}
        className="mt-[39px] disabled:cursor-not-allowed mx-auto faq-box-shadow w-[247px] h-[55px] flex-shrink-0 bg-primary rounded-[10px] cursor-pointer text-white text-opacity-80 text-[14px] font-semibold flex items-center justify-center"
        onClick={handleButtonClick}
      >
        {isDashboard ? "Sblocca con il Pro" : "Sblocca Gratis"}
      </button>
    </div>
  );
};

export default OrganizerSubscribeVideoAndContent;
